import { useGetCompanyMediafilesQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { useState } from 'react';

const PAGE_SIZE = 100;

const useVideoMeiafiles = (companyId: string, query?: string) => {
  const [page, setPage] = useState(0);
  const { data, loading, error, refetch, fetchMore } = useGetCompanyMediafilesQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    variables: {
      filters: { companyId, query },
      pagination: { page: 0, pageSize: PAGE_SIZE },
    },
  });

  const getMoreCompanyMediafiles = () => {
    if (!data?.smartlkCompanyMediafilesQuery.paginationInfo.hasNextPage) return;
    fetchMore({
      updateQuery: (prev, { fetchMoreResult }) => {
        setPage(fetchMoreResult.smartlkCompanyMediafilesQuery.paginationInfo.page);
        const data = {
          ...prev,
          smartlkCompanyMediafilesQuery: {
            ...prev?.smartlkCompanyMediafilesQuery,
            ...fetchMoreResult?.smartlkCompanyMediafilesQuery,
            result: [
              ...(prev?.smartlkCompanyMediafilesQuery?.result || []),
              ...(fetchMoreResult?.smartlkCompanyMediafilesQuery?.result || []),
            ],
            paginationInfo: {
              ...prev.smartlkCompanyMediafilesQuery.paginationInfo,
              ...fetchMoreResult.smartlkCompanyMediafilesQuery.paginationInfo,
            },
          },
        };

        return data;
      },
      variables: {
        pagination: { page: page + 1, pageSize: data.smartlkCompanyMediafilesQuery.paginationInfo.pageSize },
      },
    });
  };

  return {
    error,
    loading,
    getMoreCompanyMediafiles,
    refetch,
    companyMediafiles: data?.smartlkCompanyMediafilesQuery.result,
    companyMediafilesPaginationInfo: data?.smartlkCompanyMediafilesQuery.paginationInfo,
  };
};

export default useVideoMeiafiles;
